import React from 'react';
import {
  ModalFooter,
  ComposedModal,
  ModalHeader,
  ModalBody,
  Button
} from 'carbon-components-react';
import PreviewContent from './content';
import { CloudDownload16 } from '@carbon/icons-react';
import { getEmailAttachment } from 'utilities/helper.util';

export const PreviewModal: React.FC<Props> = ({
  email,
  onClose,
  onDownload,
  isEMLNotAvailable
}) => {
  return (
    <div className="history-page enquiry-history-preview-emails">
      <ComposedModal open={email !== undefined} onClose={() => onClose()}>
        <ModalHeader label="Preview email">
          {email.subject}
          <div className="enquiry-history-display-attachments">
            {email?.Attachments?.filter(
              (item: any) => item.mimeType !== 'message/rfc822'
            ).map((attachment: any) => {
              return (
                <Button
                  key={attachment.id}
                  kind="tertiary"
                  size="field"
                  renderIcon={CloudDownload16}
                  onClick={() =>
                    getEmailAttachment({
                      url: attachment.url,
                      attachmentName: attachment.name
                    })
                  }
                >
                  {attachment.name}
                </Button>
              );
            })}
          </div>
        </ModalHeader>
        <ModalBody>
          <PreviewContent email={email} />
        </ModalBody>
        <ModalFooter>
          <Button
            kind="secondary"
            onClick={() => onDownload()}
            disabled={isEMLNotAvailable}
          >
            Download email
          </Button>
          <Button kind="primary" onClick={() => onClose()}>
            Close
          </Button>
        </ModalFooter>
      </ComposedModal>
    </div>
  );
};

type OwnProps = {
  onClose: Function;
  email: any;
  onDownload: Function;
  isEMLNotAvailable?: boolean;
};

type Props = OwnProps;

export default PreviewModal;
